export enum ForgotPasswordStep {
  Form = 'form',
  Success = 'success',
}
